import { Component, Input, Output, OnDestroy,
         OnChanges, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-dialogue',
  templateUrl: './dialogue.component.html',
  styleUrls: ['./dialogue.component.less']
})

export class DialogueComponent implements OnChanges, OnDestroy {
  @Input() closable = true;
  @Input() visible: boolean;
  @Input() wide: boolean = false; // Full width style
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() dismissed: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  public ngOnChanges(changes): void {
    if (changes.visible !== undefined) {
      let body = document.getElementsByTagName('body')[0];
      if (changes.visible.currentValue) {
        if(body.className.search('modal-open') === -1){
          body.className = body.className + 'modal-open';
        }
      } else{
        body.className = body.className.replace('modal-open', '');
      }
    }
  }

  public ngOnDestroy() {
    let body = document.getElementsByTagName('body')[0];
    body.className = body.className.replace('modal-open', '');
  }


  public close(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.dismissed.emit();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/dialogue/dialogue.component.ts